import { useMemo } from "react";
import moment from "moment";

const useProductData = (fetchData) => {
  const data = fetchData;
  // console.log("checking data in product", fetchData);

  const formattedData = useMemo(() => {
    const rows = [];

    if (data && Array.isArray(data)) {
      data.forEach((orderItem, index) => {
        const product = orderItem.Product;
        const customer = orderItem.Order?.Customer;
        const order = orderItem.Order;

        if (product) {
          const row = {
            id: index,
            picture:
              product.Pictures?.map((picture) => ({
                id: picture.id,
                picture: picture.pic
                  .split("http")
                  .filter(Boolean)
                  .map((url) => `http${url.trim()}`),
              })) || [],
            product_id: product.id,
            product_code: product.product_code,
            product_name: product.product_name,
            product_code_com: product.product_code_com || "",
            notes: product.notes || "",
            category_id: product.category_id,
            detail: product.detail,
            blemishes: product.blemishes,
            size: product.size,
            price: product.price,
            total_price: product.total_price,
            total_amount: product.total_amount,
            created_date: moment(product.created_date).format(
              "DD/MM/YYYY\n เวลา HH:mm:ss น."
            ),
            updated_date: moment(product.updated_date).format(
              "DD/MM/YYYY\n เวลา HH:mm:ss น."
            ),
            customer_id: customer?.id,
            customer_name: customer?.name,
            idcard: customer?.idcard,
            customer_image: customer?.image,
            customer_address: customer?.address,
            customer_phonenumber: customer?.phonenumber,
            prefix: customer.prefix || "",
            nationality: customer.nationality || "",
            order_status: order?.order_status,
            selling_amount: orderItem.selling_amount,
            payment_channel: orderItem.payment_channel,
            market_channel: orderItem.market_channel,
            slip_pictures: orderItem.slip_pictures
              ? orderItem.slip_pictures
                  .split("http")
                  .filter(Boolean)
                  .map((url) => `http${url.trim()}`)
              : null,
            order_total_price: orderItem.total_price,
            order_price: orderItem.price,
            order_id: orderItem.order_id,
          };

          rows.push(row);
        }
      });
    }

    // console.log("this is a data", rows);

    return rows;
  }, [data]);

  return formattedData;
};

export default useProductData;
